// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gq-0";